import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog, MatTableDataSource, MatPaginator, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { IProcedureComponent } from 'src/app/models/IProcedures';
import { ProceduresService } from 'src/app/Services/NewVisitNote/procedures.service';


@Component({
  selector: 'app-or-procedures',
  templateUrl: './or-procedures.component.html',
  styleUrls: ['./or-procedures.component.css']
})
export class OrProceduresComponent implements OnInit {
  selectedRowIndex: number = -1;
  EncProcedureForm: FormGroup;
  displayedColumns1: string[] = ['type', 'side', 'part', 'procedure', 'levels', 'steroids', 'cptcode', 'abn', 'qty', ];

  proceduresComponent: IProcedureComponent[] = [];
  dataSourceProcedures = new MatTableDataSource(this.proceduresComponent);

  public selctedProcedureCode: IProcedureComponent;

  constructor(private fb: FormBuilder
    , private router: Router
    , private proService: ProceduresService
    , private toastr: ToastrService
    , public dialog: MatDialog
    , public dialogRef: MatDialogRef<OrProceduresComponent>,
  ) { }

  ngOnInit() {
    this.EncProcedureForm = this.fb.group(
      {
        searchTerm: [''],
        dataSourceProcedures: [],
        dataSource2: []
      });

    if (CommonComponents.encounterId && CommonComponents.patientId) {
      this.getEncProceduresInfoById(CommonComponents.encounterId, CommonComponents.patientId);
    }


    this.EncProcedureForm.get('searchTerm').valueChanges.subscribe(
      value => {
        this.dataSourceProcedures.data = this.onIcdCodeSearcClick(value);
      });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onIcdCodeSearcClick(searchString: string) {
    return this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
  }



  DiagOkClick() {
    this.dialogRef.close(this.selctedProcedureCode);
  }

  getEncProceduresInfoById(encId: string, patId: number) {
    this.proService.getPatientProcByEncId(encId, patId)
      .subscribe(
        (encProcInfo: IProcedureComponent[]) => {
          this.proceduresComponent = encProcInfo;
          this.dataSourceProcedures.data = this.proceduresComponent;
        },
        (err: any) => console.log(err)
      );
  }

  onProcedureClick(pro: IProcedureComponent) {

    var elemt = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureName === pro.procedureName);
    this.selctedProcedureCode = elemt[0];
   
  }

  oncellclick(element) {
    this.selectedRowIndex = element.procCompId;

  }

  dropTable(event){}

}
